import type { CostPlan } from '@api/ShiftGeneratorResultService';
import { useCostPlanEntry } from '@stores/shiftGeneratorResultStore';
import { useParams } from 'react-router';
import { useMemo } from 'react';

const useCostPlan = (): {
    employeeDailyWorkTimeAndCosts: CostPlan['elements'] | undefined;
    departmentId: string | undefined;
    taskId: string | undefined;
    isLoadingEmployeeDailyCosts: boolean;
} => {
    const { departmentId, taskId } = useParams<{
        departmentId: string;
        taskId: string;
    }>();

    const { response: costPlan, isLoading: isLoadingEmployeeDailyCosts } =
        useCostPlanEntry(departmentId, taskId);

    const employeeDailyWorkTimeAndCosts = useMemo(
        () => costPlan?.elements,
        [costPlan],
    );

    return {
        employeeDailyWorkTimeAndCosts,
        departmentId,
        taskId,
        isLoadingEmployeeDailyCosts,
    };
};

export default useCostPlan;
